import { ApiError } from '@/shared/api'

export type ParsedAuthError = {
  code?: string
  message: string
}

export function parseAuthError(error: unknown): ParsedAuthError {
  if (!(error instanceof ApiError)) {
    return { message: 'Не удалось выполнить запрос. Попробуйте снова.' }
  }

  try {
    const payload = JSON.parse(error.message) as Record<string, unknown>
    const payloadError =
      typeof payload.error === 'object' && payload.error !== null
        ? (payload.error as Record<string, unknown>)
        : null

    const code =
      typeof payload.code === 'string'
        ? payload.code
        : typeof payload.reason === 'string'
          ? payload.reason
          : typeof payloadError?.code === 'string'
            ? payloadError.code
            : typeof payloadError?.reason === 'string'
              ? payloadError.reason
              : undefined

    const rawMessage =
      typeof payload.message === 'string'
        ? payload.message
        : typeof payloadError?.message === 'string'
          ? payloadError.message
          : 'Не удалось выполнить запрос. Попробуйте снова.'

    return { code, message: localizeAuthErrorMessage(code, rawMessage) }
  } catch {
    return {
      message: localizeAuthErrorMessage(undefined, error.message),
    }
  }
}

function localizeAuthErrorMessage(code: string | undefined, message: string | undefined) {
  if (code === 'INVALID_CREDENTIALS') {
    return 'Неверный email или пароль.'
  }

  if (code === 'VALIDATION_ERROR' && message === 'Validation failed') {
    return 'Проверьте корректность введенных данных.'
  }

  if (message === 'Invalid email or password') {
    return 'Неверный email или пароль.'
  }

  if (message === 'Validation failed') {
    return 'Проверьте корректность введенных данных.'
  }

  return message || 'Не удалось выполнить запрос. Попробуйте снова.'
}
